module.exports = __webpack_public_path__ + "static/SFMono-MediumItalic-ae7ea80fb472a7d27aa69b3cf00f487c.woff2";